import React from 'react';
import { Checkbox, FormControl, MenuItem, Select, InputLabel } from '@mui/material';
import { alpha } from '@mui/material/styles';

function FilterMultiSelect({ label, value, onChange, options, maxCharacters = 30, sx }) {
    return (
        <FormControl variant="outlined" color="primary" size="small" sx={{ minWidth: 200, ...sx }}>
            <InputLabel
                sx={{
                    fontSize: '13px',
                    fontWeight: 700,
                    top: '4px',
                    left: '-4px',
                    width: '100%',
                    color: alpha('#3b3c3b', 0.6),
                }}
            >
                {label}
            </InputLabel>
            <Select
                label={label}
                multiple
                variant={'outlined'}
                value={value}
                onChange={(e) => onChange(e.target.value)}
                renderValue={(selected) => {
                    const selectedOptions = options.filter((o) => selected.includes(o.value));
                    let displayText = '';
                    let visible = [];
                    let moreCount = 0;

                    for (const opt of selectedOptions) {
                        const text = opt.name;
                        const potential = visible.length === 0 ? text : `${displayText}, ${text}`;
                        const remaining = maxCharacters - (`${moreCount} more`.length + 2);

                        if (potential.length <= remaining) {
                            visible.push(text);
                            displayText = potential;
                        } else {
                            moreCount = selectedOptions.length - visible.length;
                            break;
                        }
                    }

                    return (
                        <>
                            {visible.join(', ')}
                            {moreCount > 0 && `, ${moreCount} more`}
                        </>
                    );
                }}
            >
                {options.map((opt) => (
                    <MenuItem key={opt.value} value={opt.value} sx={{ paddingTop: 0, paddingBottom: 0 }}>
                        <Checkbox checked={value.includes(opt.value)} color="primary" />
                        {opt.name}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
}

export default FilterMultiSelect;
